module.exports = __webpack_public_path__ + "static/media/logo-sgu.e49c5755.png";